import React from "react";
import { Button } from "react-bootstrap";

export const Contact = () => {
  return (
    <section className="section d-flex flex-column justify-content-center align-items-center" id="contact">
        <h4 className="text-center">
          <span style={{ color: "aqua" }}>IV. What's Next?</span>
        </h4>
        <h2 className="text-light text-center" style={{ fontWeight: "bold" }}>
          Let's Get In Touch
        </h2>
        <p className="fs-4 text-secondary text-center w-50">Want to collaborate on new cool projects. Want to hire me for developer roles? I'm open to freelance projects and for other opportunities as well. Let's discuss about it.</p>
        <a href="mailto:piyushkesarwan2207@gmail.com"><Button className="btn">Say Hello</Button></a>
    </section>
  );
};
